export default "__VITE_ASSET__COIL0a4s__"